
import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator'

import type { Theme } from '~/types/theme'
import { AlButton } from '~/components/ui'

@Component({
  components: { AlButton },
})
export default class SimpleOfferCardLayout extends Vue {
  @Prop({
    required: false,
    default: 'light',
    type: String,
  })
  readonly theme!: Theme

  @Prop({
    required: true,
    default: '',
    type: String,
  })
  readonly url!: string

  @Emit('click')
  onClick () {
    return true
  }
}
